import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { getTranslation, getUser } from '@/store/getters'
import { duplicateMagazine, transferTemplateMagazine, toggleToaster, showAlert, closeAlert } from '@/store/actions'
import { TemplatesResource } from '@/resources'

import styles from './styles.scss'

/** Components */
import MagazineCover from '../MagazineCover'

class TemplateCard extends Component {
  state = {
    premium: false,
    templates: [],
    category: 'all_templates',
    showSelect: false,
    templateSelect: {}
  }

  componentDidMount() {
    TemplatesResource.index()
      .then(({ data }) => {
        const { is_premium: premium, templates } = data
        this.setState({ premium, templates, allTemplates: templates })
      })
      .catch(error => console.error(error))
  }

  handleTemplateSelect = (template) => {
    const { translation, user: { user }, transferTemplateMagazine, toggleToaster, showAlert, closeAlert } = this.props
    const { id, id_domain, title, description, properties } = template
    const { id_usuario } = user

    showAlert({
      title: translation('general-template-selection'),
      message: translation('general-template-selection-message'),
      type: 'info',
      hasCancel: true,
      callback: () => {
        transferTemplateMagazine(id, { id_usuario, id_domain, title, description, properties })
        closeAlert()
        toggleToaster({
          isVisible: true,
          message: translation('general-template-transfer-success'),
          position: 'top-right',
          type: 'success'
        })
      }
    })
  }

  handleCategory = category => {
    let templates

    switch (category) {
      case 'all_templates':
        templates = this.state.allTemplates
        this.setState({ category: 'all_templates', templates })
        break

      case 'premium':
        templates = this.state.allTemplates.filter(template => !!+template.template_premium)
        this.setState({ category: 'premium', templates })
        break

      default:
        this.setState({ category: 'all_templates' })
    }
  }

  handleTemplateSearch = () => {
    const { search } = this.props
    const { templates } = this.state

    const filteredTemplates = templates.filter(({ title }) => (
      title.toLowerCase().indexOf(search.toLowerCase()) !== -1
    ))

    return filteredTemplates
  }

  render() {
    const { translation } = this.props

    let { templates } = this.state
    templates = this.handleTemplateSearch()

    return (
      <React.Fragment>
        {templates.map(template => (
          <div
            key={template.id}
            className={'ba-card ba-no-padding ba-200'}
          >
            <div className={"ba-top " + styles['ba-display']}>
              <picture className={styles['ba-img']}>
                <MagazineCover magazineID={template.id} />
              </picture>

              <div className={styles['ba-absolute']}>
                <span className={'ba-montserrat-700 ba-color-white1 ' + styles['ba-title']}>
                  {template.title}
                </span>
                <span className={'ba-color-white1 ' + styles['ba-subtitle']}>
                  {translation('general-created')}: {template.created_at}
                </span>
              </div>
            </div>

            <div className={"ba-content ba-jc-fe ba-flex ba-gp-04 ba-mg-b-1 " + styles['ba-relative']}>
              <button className={'ba-btn ba-btn-normal ba-sm ba-rounded ' + styles['ba-mg-0']}
                ba-tooltip-position='top'
                ba-tooltip-title={translation('general-select')}
                onClick={() => this.handleTemplateSelect(template)}>
                <builderall-icon code='edit' />
              </button>
              <button className={'ba-btn ba-btn-normal ba-sm ba-rounded ' + styles['ba-mg-0']}
                ba-tooltip-position='top'
                ba-tooltip-title={translation('magazine-view-template')}
                onClick={() => window.open(`/publish/${template.id}`, '_blank')}>
                <builderall-icon code='eye' />
              </button>
            </div>
          </div>
        ))
        }
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => {
  const translation = getTranslation(state)
  const user = getUser(state)
  return { translation, user }
}

export default withRouter(connect(
  mapStateToProps,
  {
    duplicateMagazine,
    transferTemplateMagazine,
    toggleToaster,
    showAlert,
    closeAlert
  }
)(TemplateCard))



// WEBPACK FOOTER //
// ./src/pages/Dashboard/components/TemplateCard/index.js